import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useContext } from "react";
import { useStyle } from "../../hooks";
import styles from "./style.module.scss";
import { ContainerContext } from "../../Context";
;
export const PopupItem = ({ className, onClick, ...props }) => {
    const Styles = useStyle(styles, '_popup-');
    const { hide } = useContext(ContainerContext);
    const handleClick = useCallback((e) => {
        if (typeof onClick === 'function') {
            onClick(e);
        }
        hide();
    }, [onClick]);
    return (_jsx("button", { ...props, className: Styles('popup-item') + (className ? ` ${className}` : ''), onClick: handleClick }));
};
